'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var Twine = require('twine');
var Modal = require('../modal');
var FormsAPI = require('../forms-api');
var Analytics = require('../../global/analytics');
var Breakpoints = require('../../global/breakpoints');
require('./signup-form');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e['default'] : e; }

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var Twine__default = /*#__PURE__*/_interopDefaultLegacy(Twine);
var Modal__default = /*#__PURE__*/_interopDefaultLegacy(Modal);
var FormsAPI__default = /*#__PURE__*/_interopDefaultLegacy(FormsAPI);
var Analytics__default = /*#__PURE__*/_interopDefaultLegacy(Analytics);
var Breakpoints__default = /*#__PURE__*/_interopDefaultLegacy(Breakpoints);

const EMAIL_SUBSCRIBE_ENDPOINT = '/content-services/subscribers';
const EMAIL_SUBSCRIBE_DATA_EXTENSION_ID = '21262AE6-6D1B-4EE6-8448-017AF8238079';
const EMAIL_SUBSCRIBE_EVENT = 'Inline signup email capture';
const INLINE_FORM_SELECTOR = 'form.js-signup-inline';
const HIDDEN_FORM_SELECTOR = '.signup--hidden';

class SignupModal extends Modal__default {
  constructor(elements, template, options) {
    super(elements, template, options);
    this.Breakpoints = new Breakpoints__default();
    this.$inlineForm = document.querySelectorAll(INLINE_FORM_SELECTOR);
    this.$inlineForm.forEach(form => form.addEventListener('submit', this._onInlineSubmit.bind(this)));
    this.$signupForm = document.querySelector(HIDDEN_FORM_SELECTOR);
  }

  render() {
    this.modalDom.$modal.innerHTML = this.template();
    this.modalDom.$modal.querySelector('.signup-modal__content').appendChild(this.$signupForm);
  }

  open(evt, options = {}) {
    super.open(evt);
    const modalForm = this.$signupForm.querySelector('.signup-form');
    modalForm.setAttribute('id', 'SignupForm_modal');
    this.modalDom.$modalControls.classList.add('signup-modal__controls');
    Twine__default.bind(this.$signupForm).refresh();
    this.modalForm = ShopifyMarketing.context[modalForm.dataset.namespace];

    if (options.emailToPopulate) {
      this.modalForm.populateEmail(options.emailToPopulate);
    } else if (this.Breakpoints.isDesktop()) {
      this.modalForm.focusOnField('email');
    }
  }

  close(...args) {
    if (this.modalForm) {
      let gaData = Object.keys(this.modalForm.fields).reduce((result, fieldName) => {
        const field = this.modalForm.fields[fieldName];
        result[fieldName] = field.state.filled;
        return result;
      }, {});
      gaData = JSON.stringify(gaData);
      Analytics__default.track('threefield', 'modalclose', gaData);
      this.modalForm.eachField(field => {
        field.setState({
          error: false,
          focus: false,
          filled: false,
          success: false,
          pending: false,
          hint: '',
          value: '',
          errors: {}
        });
      });
    }

    super.close(args);
    this.modalDom.$modalControls.classList.remove('signup-modal__controls');
  }

  captureEmail(email) {
    return _asyncToGenerator__default(function* () {
      const valid = Object.keys(FormsAPI__default.validateEmail(email)).length === 0;

      if (!valid) {
        Analytics__default.track(EMAIL_SUBSCRIBE_EVENT, 'Invalid email');
        return;
      }

      try {
        const data = new FormData();
        data.append('email', email);
        data.append('data_extension_key', EMAIL_SUBSCRIBE_DATA_EXTENSION_ID);
        data.append('signup_page', window.location.href);
        yield fetch(EMAIL_SUBSCRIBE_ENDPOINT, {
          method: 'POST',
          credentials: 'include',
          mode: 'no-cors',
          body: data
        });
        Analytics__default.track(EMAIL_SUBSCRIBE_EVENT, 'Success');
      } catch (error) {
        Analytics__default.track(EMAIL_SUBSCRIBE_EVENT, 'Error');
      }
    })();
  }

  _onInlineSubmit(evt) {
    evt.preventDefault();
    Analytics__default.track('threefield', 'submit', 'inline form');
    const email = evt.currentTarget.elements['signup[email]'].value;
    this.open(evt, {
      emailToPopulate: email
    });
    this.$modalTrigger = evt.currentTarget.querySelector('button[type="submit"]');
    this.captureEmail(email);
  }

}

exports.default = SignupModal;
